/**
 * BUSCA CEP
 * https://brasilapi.com.br/
 */

function zipCodeSearch() {
    let cep = document.getElementById('zip_code').value;

    if (cep !== '') {
        let url = "https://brasilapi.com.br/api/cep/v1/" + cep;

        let req = new XMLHttpRequest();
        req.open('GET', url);
        req.send();

        //tratar a resposta da requisição
        req.onload = function () {
            if (req.status === 200) {
                let address = JSON.parse(req.response);
                document.getElementById('street').value = address.street;
                document.getElementById('district').value = address.neighborhood;
                // document.getElementById('city').value = address.city;
                // document.getElementById('state').value = address.state;
                selectStateCity('state', 'city', address.state, address.city);
            } else if (req.status === 404) {
                console.log('CEP inválido');
            } else {
                console.log('Erro ao fazer requisição');
            }
        }
    }
}

function zipCodeSearchOnload() {
    window.onload = function () {
        let cep = document.getElementById('zip_code');
        cep.addEventListener('blur', zipCodeSearch, true);
    }
}